/* unplugin-vue-components disabled */import { render } from "./HandleAIResponse.vue?vue&type=template&id=739c0e22&scoped=true"
import script from "./HandleAIResponse.vue?vue&type=script&lang=js"
export * from "./HandleAIResponse.vue?vue&type=script&lang=js"

import "./HandleAIResponse.vue?vue&type=style&index=0&id=739c0e22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739c0e22"]])

export default __exports__